import { render } from "./App.vue?vue&type=template&id=500e0433"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=500e0433&lang=css"

import exportComponent from "C:\\Users\\info\\OneDrive\\Desktop\\REPO_MARTECH\\rcstudio-front-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__